import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroConsultaReporteGlosas } from "../modelo/ReporteGlosasModelo";
import { TipoReporteGlosa } from "../modelo/TipoReporteGlosa";
import {
    consultarReporteGeneral,
    consultaReporteDetalle,
    descargarXlsReporteGlosas,
    exitoXlsReporteGlosas,
    limpiarMensajesErrorReporte
} from "../modulos/ReporteGlosasActions";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import GraficaBarras from "./GraficaBarras";
import GraficaTorta from "./GraficaTorta";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { fechaInicialConsulta, fechaFinalConsulta, selectorServicios } from "../../config_general/modelo/TextosAyuda";
import SelectorDesplegable from "../../config_general/componentes/SelectorDesplegable";
import { Item } from "../../config_general/modelo/ItemsListaDesplegabe";
import { consultarMaestroTransaccionesSat } from "../../../general/modulos/maestrosActions";
import ModalXLSReporteGlosas from "./ModalXLSReporteGlosas";

class FiltroReporteGlosas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            tipoReporte: undefined,
            listaServicios: [],
            mostrarModalXLS: false
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        } else {
            this.construirItems();
        }

    }

    componentWillReceiveProps(nextProps: any) {
        const { estadoDescargaXLS, mensajeError } = nextProps;
        if (estadoDescargaXLS === REQUEST.ERROR) {
            window.alert(`Se ha presentado un error generando el archivo, ${mensajeError}`);
            this.props.dispatch(exitoXlsReporteGlosas());
        }
    }

    componentDidUpdate() {
        if (this.props.transaccionesSat && this.props.transaccionesSat.length !== 0 && this.state.listaServicios.length === 0) {
            this.construirItems();
        }
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesErrorReporte());
    }

    render() {
        const { estadoDescargaXLS } = this.props;

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Reporte De Glosas</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta Reporte De Glosas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Fecha Inicial de Operación</label>
                                                <TextoAyuda texto={fechaInicialConsulta} />
                                                <DatePickerSura name={"fechaInicial"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final de Operación</label>
                                                <TextoAyuda texto={fechaFinalConsulta} />
                                                <DatePickerSura name={"fechaFinal"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Filtro Servicios</label>
                                                <TextoAyuda texto={selectorServicios} />
                                                <SelectorDesplegable
                                                    name={"listaServicios"}
                                                    listaDesplegable={this.state.listaServicios} />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {!(submitting || invalid) &&
                                                        <a className="btns btn-success" onClick={() => this.mostrarModalDescarga(values)}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.mostrarModalXLS && this.renderModalXLS()}
                                                </Col>
                                                <Col sm={2}>
                                                    {this.renderDescargaPendiente(estadoDescargaXLS)}
                                                </Col>
                                                <Col smOffset={4} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderGraficasGlosas()}
                </Row>
            </div>
        );
    }

    renderDescargaPendiente(estadoDescargaXLS: REQUEST) {
        if (REQUEST.PENDING === estadoDescargaXLS)
            return ( <DotLoader size={25} />);
        else return false;
    }

    renderGraficasGlosas() {
        const { estado, mensajeError, reporteServicios, reporteDetalle } = this.props;
        const { tipoReporte } = this.state;

        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={`Se ha presentado un error, ${mensajeError}`} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (tipoReporte) {
                    if (tipoReporte === TipoReporteGlosa.REPORTE_GENERAL)
                        return (
                            <GraficaBarras
                                datos={reporteServicios}
                                consultaDetalle={this.consultaDetalle}
                                verBotonIrDetalle={reporteDetalle && reporteDetalle.length > 0}
                                irADetalle={this.irADetalle}
                            />);
                    if (tipoReporte === TipoReporteGlosa.REPORTE_DETALLE)
                        return (
                            <GraficaTorta
                                datos={reporteDetalle}
                                regresarReporteGeneral={this.regresarReporteGeneral}
                            />);
                    else return false;
                }
            default:
                return false;
        }
    }

    renderModalXLS() {
        return (
            <ModalXLSReporteGlosas
                verModalXLS={this.state.mostrarModalXLS}
                closeModalXLS={this.cerrarModalXLS}
                generarXLS={this.generarXLS}
            />
        );
    }

    onSubmit = (values: any) => {
        const fechaInicial = values.fechaInicial ? values.fechaInicial.valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.valueOf() : "";
        const listaServicios = values.listaServicios ? values.listaServicios : [];

        const filtro: FiltroConsultaReporteGlosas = {
            tipoReporte: TipoReporteGlosa.REPORTE_GENERAL,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            listaServicios: listaServicios
        };

        this.setState({
            tipoReporte: TipoReporteGlosa.REPORTE_GENERAL,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            filtro: filtro
        });

        this.props.dispatch(consultarReporteGeneral(filtro));
    }

    validate = (values: any) => {
        const errors = {
            listaServicios: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined
        };

        if (!values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione la fecha incial";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione la fecha final";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        if (values.fechaInicial && values.fechaFinal && this.validarListaSeleccionados(values)) {
            errors.listaServicios = "Se debe seleccionar al menos un servicio de la lista.";
        }

        return errors;
    }

    validarListaSeleccionados = (values: any) => {
        return !values.listaServicios || values.listaServicios.length === 0;
    }

    mostrarModalDescarga = (values: any) => {
        const fechaInicial = values.fechaInicial ? values.fechaInicial.valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.valueOf() : "";

        this.setState({
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            mostrarModalXLS: true
        });
    }

    cerrarModalXLS = () => {
        this.setState({ mostrarModalXLS: false });
    }

    generarXLS = (tipo: number) => {
        const filtro: FiltroConsultaReporteGlosas = {
            tipoReporte: tipo,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal
        };

        this.cerrarModalXLS();
        this.props.dispatch(descargarXlsReporteGlosas(filtro));
    }

    consultaDetalle = (codigoServicio: number) => {
        const filtro: FiltroConsultaReporteGlosas = {
            tipoReporte: TipoReporteGlosa.REPORTE_DETALLE,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            codigoServicio: codigoServicio
        };

        this.setState({
            tipoReporte: TipoReporteGlosa.REPORTE_DETALLE,
            codigoServicio: codigoServicio,
            filtro: filtro
        });

        this.props.dispatch(consultaReporteDetalle(filtro));
    }

    regresarReporteGeneral = () => {
        const { tipoReporte } = this.state;
        if (tipoReporte && tipoReporte === TipoReporteGlosa.REPORTE_DETALLE)
            this.setState({ tipoReporte: TipoReporteGlosa.REPORTE_GENERAL });
    }

    irADetalle = () => {
        const { tipoReporte } = this.state;
        if (tipoReporte && tipoReporte === TipoReporteGlosa.REPORTE_GENERAL)
            this.setState({ tipoReporte: TipoReporteGlosa.REPORTE_DETALLE });
    }

    construirItems = () => {
        const { transaccionesSat } = this.props;
        const items = [];
        transaccionesSat.filter(servicio => servicio.esGestionable)
            .forEach(servicio => {
                const item: Item = {
                    texto: servicio.nombre,
                    codigo: servicio.codigo,
                    seleccionado: false,
                    bloqueado: false
                };
                items.push(item);
            });

        this.setState({ listaServicios: items });
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        estado: R.pathOr([], ["reporte_glosas", "estado"])(store),
        estadoDescargaXLS: R.pathOr([], ["reporte_glosas", "estadoDescargaXLS"])(store),
        mensajeError: R.pathOr(undefined, ["reporte_glosas", "mensajeError"])(store),
        reporteServicios: R.pathOr([], ["reporte_glosas", "reporteServicios"])(store),
        reporteDetalle: R.pathOr([], ["reporte_glosas", "reporteDetalle"])(store)
    };
})(FiltroReporteGlosas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/componentes/FiltroReporteGlosas.tsx